import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

// `/login` used to host a separate teacher login that traded a fixed
// username/password for a hardcoded FE token. Both pages now share
// `/admin/login`, which calls uniapp-backend `POST /user/login` and
// stores a real JWT + role array. We keep this route as a stable
// redirect so old bookmarks / TeacherGuard fallbacks still land
// somewhere usable.
function LoginPage() {
  const { state } = useLocation();
  return <Navigate to="/admin/login" replace state={state} />;
}

export default LoginPage;
